import React, { Component } from 'react';

import { getRequestAPIData } from '../../../../common/function';
import Loader from '../../../../common/loader';
import SoaP_SubscriptionCheck from '../../../RestAPI/SoaPSubscription';
import FD from '../../../RestAPI/fetchData';
import AppRoutes from '../../../config/AppRoutes';
import App_data from '../../../config/App_data';
import VideoDisplayUI from './VideoDisplayUI';

export class VideoDisplay extends Component {
  constructor(props) {
    window.scrollTo(0, 0);
    super(props);
    const {
      chapterId = 1,
      // showFreePremium = true,
      id,
      index = 0,
    } = props.params;
    this.state = {
      index,
      chapterId,
      showFreePremium: true,
      videoId: id,
      videoList: [],
      fistVideoData: {},
      showLoader: true,
      title: 'Title',
      urlId: 'URL ID',
      urlIdQq: '',
      chapterName: 'Chapter Name',
      pdfFile: null,
      errorMessage: '',
      isReportSectionOpen: false,
      reportContent: '',
      isVideoSaved: false,
      showPremiumModel: false,
      showPremiumLoader: true,
      isFlashCardHidden: true,
    };
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  componentDidMount() {
    const { chapterId } = this.state;
    const data = getRequestAPIData({ chapter_id: chapterId });
    this.getChapterWiseVideoList(data);
    this.getChapterData(data);
    this.getProfileInfo(data);
  }

  getProfileInfo = async data => {
    try {
      const response = await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data);
      if (response.success === true || response.success === 'true') {
        const {
          profileInfo: { exam_selected },
        } = response;
        // if (exam_selected === '') {
        //   return this.toggleAlert();
        // } else {
        const dataObject = exam_selected ? JSON.parse(exam_selected) : null;
        const data = getRequestAPIData({ examid: dataObject });
        this.getExamsByUser(data);
        // }
      }
    } catch (error) {
      this.setState({
        showLoader: false,
        errorMessage: error.message,
      });
    }
  };

  getExamsByUser = async data => {
    const response = await FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, data);
    if (response.success) {
      const { examData } = response;
      let isContentAccessible = false;
      isContentAccessible = SoaP_SubscriptionCheck.checkSoaPVideosSubscription('soa_p', examData);
      if (isContentAccessible) {
        this.setState({ showFreePremium: false });
      }
      this.setState({ showPremiumLoader: false });
    }
  };

  getChapterWiseVideoList = async data => {
    try {
      const response = await FD.callAPI(
        `${App_data.backend_api}/soa_p_videos/getSoaPVideosChapterwise`,
        data,
      );
      if (response.success === true || response.success === 'true') {
        const { soapvchapterfirst: fistVideoData, soapvchapter: videoList } = response;
        this.setState({
          videoList,
          fistVideoData,
        });
        const { index } = this.state;
        this.setVideoState(videoList[index], index);
      } else {
        this.setState({ errorMessage: response.message });
      }
      this.setState({ showLoader: false });
    } catch (error) {
      this.setState({
        showLoader: false,
        errorMessage: error.message,
      });
    }
  };

  getChapterData = async data => {
    try {
      const response = await FD.callAPI(`${App_data.backend_api}/soa_p_videos/getSoaPVideos`, data);
      const { chapterId } = this.state;
      if (response.success === true || response.success === 'true') {
        const chapterDetails = response.soapvideo.find(
          element => parseInt(element.chapter_no, 10) === parseInt(chapterId, 10),
        );
        if (chapterDetails) this.setState({ chapterName: chapterDetails.chapter_name });
      } else {
        this.setState({ errorMessage: response.message });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
        errorMessage: error.message,
      });
    }
  };

  getSavedVideo = async videoId => {
    try {
      const data = getRequestAPIData({ question_id: videoId });
      const response = await FD.callAPI(`${App_data.backend_api}/soa_p_videos/getFavVideo`, data);
      if (response.success) {
        this.setState({ isVideoSaved: true, isFlashCardHidden: false });
      } else {
        this.setState({ isFlashCardHidden: true });
      }
    } catch (error) {
      this.setState({ errorMessage: error.message });
    }
  };

  setVideoState = (item, index) => {
    this.setState({
      videoId: item.id,
      title: item.title,
      urlId: item.url_id,
      urlIdQq: item.url_id_qq,
      pdfFile: item.pdf_file,
      index,
      successAlert: false,
      isVideoSaved: false,
      isReportSectionOpen: false,
    });
    this.getSavedVideo(item.id);
  };

  redirectToURL = (item, index) => {
    const { chapterId, showFreePremium } = this.state;
    this.context.router.push({
      pathname: AppRoutes.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', item.id)
        .replace(':showFreePremium', showFreePremium)
        .replace(':index', index)
        .replace(':chapterId', chapterId),
    });
  };

  goToNextVideo = () => {
    const { index } = this.state;
    this.redirectToVideo(parseInt(index, 10) - 1);
  };

  goToPreviousVideo = () => {
    const { index } = this.state;
    this.redirectToVideo(parseInt(index, 10) + 1);
  };

  getVideoUrl = index => {
    this.redirectToVideo(index);
  };

  moveToNotes = () => {
    const { chapterId } = this.state;
    this.context.router.push({
      pathname: AppRoutes.SOA_PROBABILITY_NOTES_READING.replace('(/:chapter)', `/${chapterId}`),
    });
  };

  moveToPracticeQuestion = () => {
    const { chapterId, chapterName } = this.state;
    this.context.router.push({
      pathname: AppRoutes.SOA_PROBABILITY_READING.replace('(/:chapter)', `/${chapterId}`).replace(
        '(/:chapterName)',
        `/${chapterName}`,
      ),
    });
  };

  saveVideo = async videoId => {
    const data = getRequestAPIData({ video_id: videoId });
    if (this.state.isVideoSaved) {
      const response = await FD.callAPI(
        `${App_data.backend_api}/soa_p_videos/unsaveFavVideoByUserID`,
        data,
      );

      if (response.success) {
        if (this.childRef) {
          this.childRef.deleteFlash();
        }
        this.setState({ isVideoSaved: false, isFlashCardHidden: true });
      }
      return response;
    } else {
      const response = await FD.callAPI(
        `${App_data.backend_api}/soa_p_videos/saveFavVideoByUserID`,
        data,
      );
      if (response.success) {
        this.setState({
          isVideoSaved: true,
          isFlashCardHidden: false,
        });
      } else {
        this.setState({ isFlashCardHidden: true });
      }
      return response;
    }
  };

  onReportVideo = async videoId => {
    this.setState({ reportLoading: true });
    const { index, reportContent } = this.state;
    const data = getRequestAPIData({
      videoIndex: index,
      video_id: videoId,
      comment: reportContent,
    });
    const response = await FD.callAPI(
      `${App_data.backend_api}/soa_p_videos/videoReportQuestion`,
      data,
    );
    if (response.success) {
      this.setState({
        successAlert: true,
        reportLoading: false,
      });
    }
  };

  onViewPDF = () => {
    const { pdfFile } = this.state;
    const myWindow = window.open(pdfFile);
    myWindow.focus();
  };

  toggleAlert = () => {
    this.setState({ showPremiumModel: !this.state.showPremiumModel });
  };

  checkSubscription = (func, condition) => {
    const { showFreePremium } = this.state;
    if (condition !== 1 && (showFreePremium === true || showFreePremium === 'true')) {
      this.toggleAlert();
      return;
    }
    return func();
  };

  redirectToVideo = index => {
    const { videoList } = this.state;
    const videoData = videoList[index];
    this.checkSubscription(() => {
      this.setVideoState(videoData, index);
      this.redirectToURL(videoData, index);
    }, videoData.free);
  };

  goPremium = () => {
    this.context.router.push({ pathname: '/Subscribe/' });
  };

  render() {
    const {
      videoList,
      showFreePremium,
      videoId,
      title,
      urlId,
      urlIdQq,
      pdfFile,
      showLoader,
      chapterName,
      errorMessage,
      successAlert,
      isReportSectionOpen,
      isVideoSaved,
      showPremiumModel,
      showPremiumLoader,
      isFlashCardHidden,
    } = this.state;

    return (
      <div className='animated fadeIn coming_soon_wrap'>
        {/* {console.log('showPremiumLoader && showLoader', showPremiumLoader, showLoader)} */}
        {showPremiumLoader || showLoader ? (
          <Loader />
        ) : errorMessage ? (
          <h4>{errorMessage}</h4>
        ) : videoList.length ? (
          <VideoDisplayUI
            videoList={videoList}
            showFreePremium={showFreePremium}
            videoId={videoId}
            isFlashCardHidden={isFlashCardHidden}
            setChildRef={this.setChildRef}
            title={title}
            urlId={urlId}
            urlIdQq={urlIdQq}
            pdfFile={pdfFile}
            chapterName={chapterName}
            getVideoUrl={this.getVideoUrl}
            goToPreviousVideo={this.goToPreviousVideo}
            goToNextVideo={this.goToNextVideo}
            moveToNotes={this.moveToNotes}
            moveToPracticeQuestion={this.moveToPracticeQuestion}
            saveVideo={this.saveVideo}
            reportVideo={this.reportVideo}
            onViewPDF={this.onViewPDF}
            isVideoSaved={isVideoSaved}
            successAlert={successAlert}
            showPremiumModel={showPremiumModel}
            checkSubscription={this.checkSubscription}
            toggleReportSection={() => this.setState({ isReportSectionOpen: !isReportSectionOpen })}
            isReportSectionOpen={isReportSectionOpen}
            setContent={event => {
              this.setState({ reportContent: event.target.value });
            }}
            onReportVideo={this.onReportVideo}
            toggleAlert={this.toggleAlert}
            goPremium={this.goPremium}
            moveToVideoLessons={() =>
              this.context.router.push({ pathname: AppRoutes.SOA_PROBABILITY_VIDEO_LESSONS })
            }
          />
        ) : (
          <h4>No Data Found</h4>
        )}
      </div>
    );
  }
}

export default VideoDisplay;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/VideoDisplay/index.jsx